import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';
import { Transaction } from '../models/transaction';
import { TransactionSummary } from '../models/transaction-summary';
import { environment } from '../../environments/environment.development';

@Injectable({
  providedIn: 'root'
})
export class MasterService {

  private apiURL=environment.aureuscoinservice;//environment.aureuscoinservice;
  constructor(private http: HttpClient) { }

  getAllTransaction():Observable <Transaction[]>{
debugger;
console.log(this.apiURL);
    return this.http.get<Transaction[]>(this.apiURL+'api/cointransfer/allTransaction');
  }
  getDailyTotals():Observable <any[]>{
    return this.http.get<any[]>(this.apiURL+'api/cointransfer/last14days');

  }
  getSummary(): Observable<TransactionSummary> {
    return this.http.get<TransactionSummary>(this.apiURL+'api/cointransfer/summary');
  }
  searchTxnHash(keyword: string): Observable<Transaction[]> {
    const params = new HttpParams().set('keyword', keyword);
    return this.http.get<Transaction[]>(`${this.apiURL}api/cointransfer/searchTxnHash`, { params });
  }



}
